<template>
  <div class="container">
    <!-- Колонка с цветовыми индикаторами -->
    <div class="indicator-column" ref="indicatorColumn">
      <div
          v-for="(line, index) in indicatorLines"
          :key="index"
          class="line-indicator"
          :style="{ height: lineHeight + 'px' }"
          :class="{ eq: line === 'eq', em: line === 'em', df: line === 'df' }"
      ></div>
    </div>

    <!-- Текстовые области -->
    <textarea
        class="left-textarea"
        v-model="leftText"
        placeholder="Левая текстовая область"
        ref="leftTextarea"
        @blur="onBlur"
        :style="{ lineHeight: lineHeight + 'px' }"
    ></textarea>
    <textarea
        class="right-textarea"
        v-model="rightText"
        placeholder="Правая текстовая область"
        ref="rightTextarea"
        @blur="onBlur"
        :style="{ lineHeight: lineHeight + 'px' }"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: 'TextEditorWithIndicators',
  data() {
    return {
      leftText: '',
      rightText: '',
      lineColors: [],
      lineHeight: 20, // Фиксированная высота строки в пикселях
      mainSymbolRegExp: /[^a-zA-Zа-яА-ЯёЁ]/g
    }
  },
  computed: {
    leftLines() {
      return this.leftText.split('\n');
    },
    rightLines() {
      return this.rightText.split('\n');
    },
    indicatorLines() {
      const left = this.leftText.split('\n');
      const right = this.rightText.split('\n');
      const biggest = left.length > right.length ? left : right;
      const result = [];
      for (let i = 0; i < biggest.length; i++) {
        const l = left[i];
        const r = right[i];

        if (l && !r || !l && r) {
          result.push('em');
        } else {
          result.push(l === r ? 'eq' : 'df');
        }
      }
      return result;
    }
  },
  mounted() {
    // Инициализируем высоту индикаторов
    this.syncIndicatorHeight();
  },
  methods: {
    syncIndicatorHeight() {
      // Убедимся, что высота textarea соответствует количеству строк
      const textarea = this.$refs.leftTextarea;
      const indicators = this.$refs.indicatorColumn;

      if (textarea && indicators) {
        indicators.style.height = textarea.scrollHeight - this.lineHeight + 'px';
      }
    },
    onBlur() {
      this.correlateLists(this.leftText, this.rightText);
    },
    normalizeInputList(inputList) {
      const lines = inputList?.split('\n') || [];
      return [...new Set(
          lines.filter(l => l).map(l => l.trim()).filter(l => l)
      )].sort()
    },
    correlateLists(leftInput, rightInput) {
      const left = this.normalizeInputList(leftInput);
      const right = this.normalizeInputList(rightInput);

      const resultLeft = [];
      const resultRight = [];

      let i = 0, j = 0;

      while (i < left.length || j < right.length) {
        const leftItem = i < left.length ? left[i] : null;
        const rightItem = j < right.length ? right[j] : null;

        // Если элементы похожи (по вашему критерию), сопоставляем их
        if (leftItem && rightItem && this.areItemsSimilar(leftItem, rightItem)) {
          resultLeft.push(leftItem);
          resultRight.push(rightItem);
          i++;
          j++;
        }
        // Если левый элемент "меньше" (по вашему критерию сортировки)
        else if (!rightItem || (leftItem && leftItem < rightItem)) {
          resultLeft.push(leftItem);
          resultRight.push("");
          i++;
        }
        // Если правый элемент "меньше"
        else {
          resultLeft.push("");
          resultRight.push(rightItem);
          j++;
        }
      }
      // resultLeft.push('\n');

      this.leftText = resultLeft.join('\n');
      this.rightText = resultRight.join('\n');

    },
    areItemsSimilar(a, b, threshold = 0.5) {
      // Проверяем, являются ли обе переменные строками
      if (typeof a !== 'string' || typeof b !== 'string') {
        return false;
      }

      // Приводим строки к нижнему регистру
      a = a.toLowerCase();
      b = b.toLowerCase();

      // Вычисляем коэффициент схожести
      const similarity = this.calculateSimilarity(a, b);

      // Сравниваем с порогом
      return similarity >= threshold;
    },
    calculateSimilarity(str1, str2) {
      const longer = str1.length > str2.length ? str1 : str2;
      const shorter = str1.length > str2.length ? str2 : str1;

      let matches = 0;
      let i = 0;
      let j = 0;

      while (i < longer.length && j < shorter.length) {
        if (longer[i] === shorter[j]) {
          matches++;
          j++;
        }
        i++;
      }

      return (2.0 * matches) / (str1.length + str2.length);
    }
  },
  watch: {
    leftText() {
      this.$nextTick(() => {
        this.syncIndicatorHeight();
      });
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  min-height: calc(100vh - 10px);
  width: 100vw;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.indicator-column {
  width: 30px;
  background-color: #f5f5f5;
  border-right: 1px solid #ddd;
  overflow-y: hidden;
  margin-top: 20px;
}

.line-indicator {
  width: 100%;
  border-bottom: 1px solid #e0e0e0;
  box-sizing: border-box;
}

.left-textarea, .right-textarea {
  flex: 1;
  min-height: calc(100%);
  resize: none;
  outline: none;
  font-size: 16px;
  box-sizing: border-box;
  overflow-y: hidden;
  font-family: monospace;
  line-height: 20px;
  overflow-x: auto;
  white-space: nowrap;
  border: none;

  padding: 20px;
  background-image: linear-gradient(#F1F1F1 50%, #F9F9F9 50%);
  background-size: 100% 40px;
}

.right-textarea {
  border-left: 1px solid darkgray;
}

.left-textarea {
  border-right: 1px solid #ccc;
}

.line-indicator.eq {
  background: green;
}

.line-indicator.df {
  background: orange;
}

.line-indicator.em {
  background: red;
}


</style>
